/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {WinPresentationController} from "../WinPresentationController";
import {gsap} from "gsap";
import {Serial} from "../../Serial";
import {SerialSound} from "../../sound/SerialSound";

export class BreakBankController extends WinPresentationController {

    constructor() {
        super("BreakBankController", false);
    }

    protected hasWin():boolean {
        return Serial.model.parsedGameData.brokeTheBank;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = gsap.timeline();
        tl.add(() => {
            Serial.xBetController.buttonsVisible = false;
            SerialSound.fadeMusic(0, 1);
            if(Serial.model.parsedGameData.currentWinRatioConfig!.bigWinLevel > -1) {
                SerialSound.soundPlayer.playTrack({name : SerialSound.BIG_WIN_LEVEL_CHANGE});
            }
        }, 0);
        let delay = 0.1;
        if(Serial.model.parsedGameData.totalSpinWinnings > 0) {
            delay += 0.3;
        }
        tl.to(this, {duration : delay});
    }
}